import { createAsyncThunk } from '@reduxjs/toolkit';
import jobApi from '~/apis/job';
import {
  ADDITIONAL_EXPENSE,
  CHANGE_STATUS_JOB,
  CONVERT_TO_SCHEDULE,
  CREATE_JOB,
  DELETE_JOB,
  GET_DETAIL_JOB,
  GET_LIST,
  GET_LIST_JOB_ITEM,
  GET_LIST_JOB_KANBAN,
  UPDATE_JOB,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  IChangeStatusJob,
  IFormConvertJobToSchedule,
  IFormJob,
  IFormJobCosting,
  IParamQueryJobDetail,
  IParamQueryJobKanban,
  IQueryParamJob,
  IQueryParamJobItem,
} from '~/utils/interface/jobs';

export const updateJob = createAsyncThunk(UPDATE_JOB, async (body: IBodyUpdate<IFormJob>, { rejectWithValue }) => {
  try {
    const resp = await jobApi.updateJob(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const changeStatusJob = createAsyncThunk(
  CHANGE_STATUS_JOB,
  async (body: IBodyUpdate<IChangeStatusJob>, { rejectWithValue }) => {
    try {
      const resp = await jobApi.changeStatusJob(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const additionalExpense = createAsyncThunk(
  ADDITIONAL_EXPENSE,
  async (body: IBodyUpdate<IFormJobCosting>, { rejectWithValue }) => {
    try {
      const resp = await jobApi.additionalExpense(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const convertJobToSchedule = createAsyncThunk(
  CONVERT_TO_SCHEDULE,
  async (body: IBodyUpdate<IFormConvertJobToSchedule>, { rejectWithValue }) => {
    try {
      const resp = await jobApi.convertJobToSchedule(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListJob = createAsyncThunk(GET_LIST, async (params: IQueryParamJob, { rejectWithValue }) => {
  try {
    const resp = await jobApi.getListJob(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListJobKanban = createAsyncThunk(
  GET_LIST_JOB_KANBAN,
  async (params: IParamQueryJobKanban, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getListJobKanban(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getListJobItem = createAsyncThunk(
  GET_LIST_JOB_ITEM,
  async (params: IQueryParamJobItem, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getListJobItem(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailJob = createAsyncThunk(
  GET_DETAIL_JOB,
  async (params: IParamQueryJobDetail, { rejectWithValue }) => {
    try {
      const resp = await jobApi.getDetailJob(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteJob = createAsyncThunk(DELETE_JOB, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await jobApi.deleteJob(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createJob = createAsyncThunk(CREATE_JOB, async (body: IFormJob, { rejectWithValue }) => {
  try {
    const resp = await jobApi.createJob(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
